import Box from '@mui/material/Box';
import ReportAndResourcesHeader from '../ReportAndResourcesHeader';
import ViewThoughtLeadershipResources from './ViewThoughtLeadershipResources';

const ThoughtLeadershipResourcesHome = () => {

    return (
        <Box sx={{ width: '100%' }}>
            <ViewThoughtLeadershipResources />
        </Box>
    );
}

export default ThoughtLeadershipResourcesHome